var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70711 0.305288C9.61486 0.209778 9.50451 0.133596 9.38251 0.0811869C9.26051 0.0287779 9.12929 0.00119157 8.99651 3.77571e-05C8.86373 -0.00111606 8.73205 0.0241854 8.60915 0.0744663C8.48626 0.124747 8.37461 0.199 8.28071 0.292893C8.18682 0.386786 8.11257 0.498438 8.06229 0.621334C8.012 0.744231 7.9867 0.87591 7.98786 1.00869C7.98901 1.14147 8.0166 1.27269 8.06901 1.39469C8.12141 1.5167 8.1976 1.62704 8.29311 1.71929L10.5861 4.01229H1.00011C0.73489 4.01229 0.480537 4.11765 0.293 4.30518C0.105464 4.49272 0.000106812 4.74707 0.000106812 5.01229C0.000106812 5.2775 0.105464 5.53186 0.293 5.71939C0.480537 5.90693 0.73489 6.01229 1.00011 6.01229H10.5861L8.29311 8.30529C8.11095 8.49389 8.01015 8.74649 8.01243 9.00869C8.01471 9.27089 8.11988 9.5217 8.30529 9.70711C8.4907 9.89252 8.74151 9.99768 9.00371 9.99996C9.2659 10.0022 9.5185 9.90145 9.70711 9.71929L13.7071 5.71929C13.8946 5.53176 13.9999 5.27745 13.9999 5.01229C13.9999 4.74712 13.8946 4.49282 13.7071 4.30529L9.70711 0.305288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7f4d3ee7025f2445e4611911f8ad54ba.svg";
export { ForwardRef as ReactComponent };